export default __webpack_public_path__ + "static/media/v_status.6b602ee8.svg";